<template>
  <div class="mis-datos-documento-dni">
    <DocumentoCard
      :key="uriKey"
      ref="documentoDniCard"
      :title="$t('mis_datos.form.documento_dni')"
      :required="false"
      :initial-document-list="initialDocumentList"
      :actions="['open', 'download', 'replace', 'add']"
      :multiple="false"
      @added:document="onDocumentFileChanged"
      @updated:document="onDocumentFileChanged"
      @deleted:document="onDocumentDeleted"
    />
  </div>
</template>

<script setup lang="ts">
import DocumentoCard from "@components/document-card/DocumentCard.vue";
import type { IDocumentInitialState } from "@components/document-card/models/IDocumentCardProps";
import type { CardFile } from "@components/document-card/models/CardFile";
import { computed, ref } from "vue";

const props = defineProps<{
  documentUri?: string;
}>();

const emit = defineEmits<{
  pendingFile: [File | undefined];
}>();

const documentoDniCard = ref<InstanceType<typeof DocumentoCard>>();

const uriKey = computed(() => props.documentUri ?? "");

function fileNameFromDocumentoUri(uri: string): string {
  const t = uri.trim();
  if (!t) {
    return "";
  }
  try {
    const pathname = t.includes("://") ? new URL(t).pathname : t.replace(/\\/g, "/");
    const segment = pathname.split("/").filter(Boolean).pop();
    if (segment) {
      return decodeURIComponent(segment);
    }
  } catch {
    /* URL inválida: intentar último segmento del string */
  }
  const fallback = t.split(/[/\\]/).filter(Boolean).pop();
  return fallback ? decodeURIComponent(fallback) : "";
}

const initialDocumentList = computed((): IDocumentInitialState[] => {
  const uri = props.documentUri?.trim();
  if (!uri) {
    return [];
  }
  const nombreDesdeUri = fileNameFromDocumentoUri(uri);
  return [
    {
      id: "dni",
      uri,
      fileName: nombreDesdeUri || "documento",
    },
  ];
});

const onDocumentFileChanged = (ficheroSeleccionado: CardFile): void => {
  emit("pendingFile", ficheroSeleccionado.file ?? undefined);
};

const onDocumentDeleted = (): void => {
  emit("pendingFile", undefined);
};

defineExpose({
  isDocumentValid: (): boolean => documentoDniCard.value?.isValid ?? false,
  resetAfterSave: (): void => {
    documentoDniCard.value?.resetToInitial();
  },
});
</script>
